import { buildQuery } from '@calendly/http-tools'
import { useSelector } from 'react-redux'

import { isPollSelector } from 'selectors/event_type'
import { eventTypeSelector } from 'root-api'

export const useOneOffOrPollsUrl = () => {
  const { id: eventTypeId, uuid: eventTypeUuid } = useSelector(eventTypeSelector)
  const isPoll = useSelector(isPollSelector)

  const baseUrl = isPoll
    ? '/app/scheduling/polls/user/me'
    : '/app/scheduled_events/user/me'

  const queryParams = isPoll
    ? { id: eventTypeId }
    : { period: 'pending', status_ids: 'active', uuid: eventTypeUuid, expand: true }

  return `${baseUrl}?${buildQuery(queryParams)}`
}
